export default {"src":"/_next/static/media/logo-wb.053e84c8.svg","height":177,"width":902,"blurWidth":0,"blurHeight":0};